import routes from '../../../config/routes';
import classNames from '../../../lib/classnames';
import Link from '../../elements/Link';
import BrandSVG from './BrandSVG';

export interface BrandProps {
    className?: string;
    clickable?: boolean;
}

export default function Brand({ className, clickable = true }: BrandProps): JSX.Element {
    if (clickable) {
        return (
            <Link
                href={routes.home.getUrl()}
                className={classNames('my-7 flex justify-center', className)}>
                <BrandSVG />
            </Link>
        );
    }

    return (
        <div className={classNames('my-7 flex justify-center', className)}>
            <BrandSVG />
        </div>
    );
}
